import BaseRequests, { URLS } from './BaseRequests'
import { toast } from 'react-toastify'

class CertificateRequests {

  static validateCertificate(certificateKey) {
    if (!certificateKey || certificateKey.trim() === '') {
      toast.error('Por favor, insira um código de certificado válido.')
      return Promise.reject(new Error('Código de certificado vazio'))
    }

    return BaseRequests.post(URLS.VALIDATE_CERTIFICATE, {
      certificate_key: certificateKey.trim()
    }).then(
      response => {
        console.log('Validation response:', response.data)
        return response.data
      }
    ).catch(error => {
      console.error('Validation error:', error)
      if (error.response && error.response.data && error.response.data.message) {
        toast.error(error.response.data.message)
      } else {
        toast.error('Erro ao validar certificado. Tente novamente.')
      }
      throw error
    })
  }

  static get (params = {}) {
    const {
      institution,
      id,
      certificate_key = undefined,
      course_id = false,
      discipline_id = false,
      trail_id = false,
      class_id = false,
      student_id = false,
      page = 1,
      limit = 11,
      status = false,
      is_nr_certificate = false,
      is_trail_certificate,
    } = params || {}

    const resolvedInstitution = institution || id

    const data = {
      institution: resolvedInstitution,
      page,
      limit,
      discipline_id,
      course_id,
      trail_id,
      class_id,
      student_id,
    }

    if (certificate_key) data.certificate_key = certificate_key
    if (status && Array.isArray(status) && status.length) data.status = status
    if (is_nr_certificate) data.is_nr_certificate = true
    if (typeof is_trail_certificate === 'boolean') data.is_trail_certificate = is_trail_certificate
 


    return BaseRequests.post(URLS.GET_CERTIFICATES, data).then(
      response => {
         {
          return {
            certificates: response.data.certificates || [],
            total: response.data.total || 0,
            pages: response.data.pages || 1,
            current_page: response.data.current_page || 1
          }
        }
      }
    )
  }


  static generateNRCertificate(data) {
    /*validar campos obrigatórios */
    const requiredFields = [
      'institution_id',
      'enrollment_id',
      'discipline_id',
      'user_name',
      'student_signature',
      'discipline_name',
      'programmatic_content',
      'workload',
      'start_date',
      'completion_date',
      'location',
      'validity_years',
      'instructors',
      'technical_responsible',
      'technical_responsible_registration',
      'technical_responsible_signature'
    ]

    for (const field of requiredFields) {
      if (!data.hasOwnProperty(field) || data[field] === undefined || data[field] === null) {
        toast.error(`O campo obrigatório "${field}" está faltando ou vazio.`)
        return Promise.reject(new Error(`O campo obrigatório "${field}" está faltando ou vazio.`))
      }
    }
    return BaseRequests.post(URLS.GENERATE_CERTIFICATE, data).then(
      response => {
         {
          if (response.data.success === false) {
            toast.error(response.data.message || "Erro ao gerar certificado NR.")
            return Promise.reject(new Error(response.data.message))
          }

          toast.success("Certificado NR gerado com sucesso!")

      
          // force open pdf in new tab
          window.open(response.data.certificate.pdf, '_blank')
          return response.data
        }
      }
    )
  }

}

export default CertificateRequests
